import { render } from "./ProposalChangelogModal.vue?vue&type=template&id=4201c5fa&scoped=true&ts=true"
import script from "./ProposalChangelogModal.vue?vue&type=script&lang=ts"
export * from "./ProposalChangelogModal.vue?vue&type=script&lang=ts"

import "./ProposalChangelogModal.vue?vue&type=style&index=0&id=4201c5fa&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4201c5fa"]])

export default __exports__